module.exports = __webpack_public_path__ + "static/media/arrowGrayTwo.6ed2e405.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrowGrayTwo.png
// module id = 1729
// module chunks = 0 1